<template>
    <div>

    </div>
</template>
<script>
export default {
    name: 'ResentContract',
    data() {
        return {
            message: '취소된 계약 입니다',
        };
    },
    created() {
        alert(this.message);
        window.close()
    },
};
</script>